import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast';
import React, { useRef } from 'react'
import { useCambiarContrasenaContext } from '../context/cambiarContrasena.context';

const CambioContrasena = () => {

  const { state, usuario, toast,
    validarYCambiarPassword, redireccionar,
    onChangeContraseniaActual,
    onChangeNuevaContrasenia,
    onChangeRepitaNuevaContrasenia,
    handleLoading } = useCambiarContrasenaContext();


  const cambioContraseniaUsuario =
    <div className="card login-form" style={{ maxWidth: '30%' }}>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1" style={{ width: '154px' }}>Usuario</span>
        </div>
        {usuario != undefined ?
          <input className="form-control" value={usuario.login ?? ''} disabled />
          : <div></div>
        }
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1">Contraseña Actual</span>
        </div>
        <input className="form-control" type='password' value={state.contraseniaActual} onChange={(e) => onChangeContraseniaActual(e.target.value)} />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1">Nueva Contraseña</span>
        </div>
        <input className="form-control" type='password' value={state.nuevaContrasenia} onChange={(e) => onChangeNuevaContrasenia(e.target.value)} />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1">Repita Contraseña</span>
        </div>
        <input className="form-control" type='password' value={state.repitaNuevaContrasenia} onChange={(e) => onChangeRepitaNuevaContrasenia(e.target.value)} />
      </div>
      <Button className="btn btn-secondary submit-btn" label='Aceptar' onClick={validarYCambiarPassword} disabled={state.isRedirect}/>
      {handleLoading()}
      {redireccionar()}
      <Toast ref={toast} />
    </div>;

  const cambioContraseniaEdenred =
    <div>Los usarios LANET no pueden cambiar la contraseña</div>
    ;

  return (
    <div>
      {(usuario.activeDirectory === undefined || usuario.activeDirectory === false) ?
        cambioContraseniaUsuario : cambioContraseniaEdenred
      }
    </div>
  )
}

export default CambioContrasena